<template>
  <div class="addon lf-headline">
    <ApplyReplacementTags
      :tag="state.type"
      :html="text"
      :extra-replacement-tags="model.column.replacementTags"
      :style="state?.elementStyling?.inline"
      class="lf-headline__content"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, PropType } from 'vue';
import { AddonLfHeadlineModel } from '@/components/addons/lf-headline/Model';
import useFontObserver from '@/hooks/useFontObserver';
import ApplyReplacementTags from '@/components/ApplyReplacementTags.vue';

export default defineComponent({
  name: 'AddonLfHeadline',
  components: {
    ApplyReplacementTags
  },
  props: {
    model: {
      type: Object as PropType<AddonLfHeadlineModel>,
      required: true
    }
  },
  setup(props) {
    const state = (props.model as AddonLfHeadlineModel).state;

    let readyPromiseResolve: (() => void) | undefined;
    const readyPromise = new Promise<void>((resolve) => {
      readyPromiseResolve = resolve;
    });

    const text = computed(() => {
      const fallbackContent = 'Lorem ipsum dolor sit amet';
      if (state.text === '') {
        return fallbackContent;
      }
      if (state.text === undefined) {
        return fallbackContent;
      }
      return state.text;
    });

    onMounted(async () => {
      const { isFontLoaded } = useFontObserver();

      if (state.layout?.typography?.fontFamily) {
        await isFontLoaded(state.layout.typography.fontFamily);
      }
      if (readyPromiseResolve) {
        readyPromiseResolve();
      }
    });

    return {
      state,
      text,
      onBeforeEnter: async () => {
        await readyPromise;
      }
    };
  }
});
</script>
